import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  textItem?: string
  item?: React.ReactNode
}

const InfoItem = ({ label, textItem, item }: Props) => {
  return (
    <Box gap="s2">
      <Text weight="normal" size="200">
        {label}
      </Text>
      {textItem && (
        <Text weight="medium" size="200" color="grey1000">
          {textItem}
        </Text>
      )}
      {item && item}
    </Box>
  )
}

export default InfoItem
